<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3 ">
                <b-col>
                    <div>
                        <p class="font-weight-bold">C. FEES AND CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE </p>
                    </div>
                    <div>
                        <p>The following fees and charges reflect the information during your application process. </p>
                    </div>
                    <b-table-simple
                        responsive
                        striped
                        hover
                        class="text-sm text-md-md"
                    >
                        <b-thead>
                            <b-tr>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr
                                v-for="(menu, j) in data"
                                :key="j"
                                class="py-2 py-md-3"
                            >
                                <b-td class="font-weight-bold">{{ menu.key }}</b-td>
                                <b-td>
                                    <span v-html="menu.value"></span>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <div>
                        <p>	Tuition typically increases by no more than 3% each academic year. Mandatory semester fees increase every two years.</p>
                    </div>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >

                                    <div>
                                        {{ $t('confirm_information_accuracy') }}
                                    </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>


    </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    props:{
        studentInformation: {
            type: Object,
        }
    },
    data() {
        return {
            form: {},
            masks: {
                input: "DD-MM-YYYY",
            },
            data: [
            ]
        }
    },

    created() {
        this.getData()
    },
    computed: {
        ...mapGetters({
            formData: "enrollmentAgreementForm/formData"
        })
    },

    methods: {
        async getData() {
            window.scrollTo(0,0)

            this.data.push(
                {
                    key: 'Admission Confirmation Deposit',
                    value: `$${this.studentInformation.admission_confirmation_deposit?this.studentInformation.admission_confirmation_deposit:0} – Non Refundable (but credited towards tuition).`,
                },
                {
                    key: 'Tuition Deposit',
                    value: `$${this.studentInformation.tuition_deposit?this.studentInformation.tuition_deposit:0} – Non Refundable (but credited towards tuition).`,
                },
                {
                  key: 'Tuition per Credit',
                  value: `$${this.studentInformation.tuition_per_credit?this.studentInformation.tuition_per_credit:0}`,
                },
                {
                  key: 'MANDATORY FEES',
                  value: 'Student Activities and Services Fee: $135<br>Technology Fee: $165<br>Student ID Fee: $20 (only if this is your first semester at BAU)',
                },
                {
                  key: 'OTHER FEES MAY APPLY',
                  value: `For example, requests by students for official university documents (e.g., requests for transcripts, enrollment verifications and academic records) may require payment of the relevant <strong>university fees</strong>. Information about the above-mentioned <strong>university fees</strong> and other fees can be found on <a href="https://bau.edu/admissions/tuition-fees/" target="_blank" class="text-primary text-decoration-underline">Bay Atlantic University's website</a>.`,
                },
            )
        },
        async next() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.$emit('next', 1)
            }

        },
        back(){
            this.$emit('back', -1);
        }
    }
}
</script>
